import Disputes from "../../services/api/Disputes";
import { getInitialState, getPath } from "../../utils";

const initialState = {
  Filters: {},
  DisputesList: [],
  Dispute: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DISPUTES_LIST_FILTERS":
      return setDisputesListFilters(state, action);
    case "SET_DISPUTES_LIST":
      return setDisputesList(state, action);
    case "RESET_DISPUTES_LIST_AND_FILTERS":
      return resetDisputesList(state, action);
    case "SET_DISPUTES_DETAILS":
      return setDisputesDetails(state, action);
    case "RESET_DISPUTES_DETAILS":
      return resetDisputesDetails(state, action);
    default:
      return state;
  }
}

const setDisputesListFilters = (state, action) => {
  return {
    ...state,
    Filters: action.payload || {},
  };
};

const setDisputesList = (state, action) => {
  return {
    ...state,
    DisputesList: action.payload.disputes || [],
  };
};

const setDisputesDetails = (state, action) => {
  return {
    ...state,
    Dispute: action.payload.disputes || [],
  };
};

const resetDisputesDetails = (state, action) => {
  return {
    ...state,
    Dispute: initialState.Dispute,
  };
};

const resetDisputesList = (state, action) => {
  return {
    ...initialState,
  };
};
